import { render, staticRenderFns } from "./newaddcheck2.vue?vue&type=template&id=5c6ffad2&scoped=true&"
import script from "./newaddcheck2.vue?vue&type=script&lang=js&"
export * from "./newaddcheck2.vue?vue&type=script&lang=js&"
import style0 from "./newaddcheck2.vue?vue&type=style&index=0&id=5c6ffad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ffad2",
  null
  
)

export default component.exports